import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    padding: 20px;
    width: ${(props) => (props.fromSignup ? "70%" : props.maxWidth)};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 600px) {
      ${(props) =>
        props.fromSignup
          ? `
        width: 100vw;
        height: 100vh;
        border-radius: 0;
        padding: 0;
      `
          : ''}
    }
  }

  &.MuiDialog-root {
    position: ${(props) => (props.fromSignup ? "relative" : "fixed")};
    backgroundColor: ${(props) => (props.fromSignup ? "transparent" : "none")};
    height: ${(props) => (props.fromSignup ? "100vh" : "auto")};
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .close-icon {
    cursor: pointer;
  }
`;

export const Title = styled.div`
    font-weight: 700;
  color: #0F0F0F;
  font-size: 20px;
  font-family: "DM Sans", sans-serif;
`

export const IconAndTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const StyledDialogContent = styled(DialogContent)`
  font-size: 16px;
  color: #565556;
  font-weight: 700;
  line-height: 20px;
  margin-top: 10px;
  @media (max-width: 600px) {
    ${(props) =>
      props.fromSignup
        ? `
      padding: 0 !important;
      margin-top: 0;
    `
        : ''}
  }
`;

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const VerifyButton = styled(Button)`
  background-color: #6f42c1 !important;
  color: white !important;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;

  &:hover {
    background-color: #5a379c !important;
  }
`;

export const Separator = styled.div`
    border: 1px solid #E1E1E1;
`